import { useRecoilValue } from 'recoil'

import LocationDateTimeForm from '../../components/LocationDateTimeForm'
import { PLAN_TYPE } from '../../config/consts'
import { ServiceAtom } from '../../recoil/atoms'
import UserCrossVisit from './components/UserCrossVisit'
import UserVisitFrequency from './components/UserVisitFrequency'
import UserVisitPerformance from './components/UserVisitPerformance'
import UserVisitSiteRanking from './components/UserVisitSiteRanking'
import UserWeeklyTrafficPatterns from './components/UserWeeklyTrafficPatterns'
import UserVisitAnalysisBasic from './UserVisitAnalysisBasic'

function UserVisitAnalysis() {
  const service = useRecoilValue(ServiceAtom)

  if (service.planType === PLAN_TYPE.LJSDK_SUMMARY) {
    return <UserVisitAnalysisBasic />
  }
  return (
    <>
      <LocationDateTimeForm />
      <div className='grow grid xl:grid-cols-3 grid-cols-2 gap-4'>
        <UserVisitPerformance className='col-span-2' />
        <UserWeeklyTrafficPatterns className='col-span-1 row-span-2' />
        <UserVisitFrequency className='col-span-1' />
        <UserCrossVisit className='col-span-1' />
        <UserVisitSiteRanking className='col-span-3' />
      </div>
    </>
  )
}

export default UserVisitAnalysis
